import { Component, inject, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { AdminService } from '../../core/services/admin/admin.service';

interface CacheButton {
  label: string;
  service: string;
  key: string;
}

@Component({
  selector: 'app-cache-management',
  standalone: true,
  imports: [MatButton, MatCard, MatCardHeader, MatCardTitle, MatCardContent],
  templateUrl: './cache-management.component.html',
  styleUrls: ['./cache-management.component.scss'],
})
export class CacheManagementComponent implements OnDestroy {
  private readonly adminService = inject(AdminService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly destroy$ = new Subject<void>();

  public readonly cacheButtons: CacheButton[] = [
    { label: 'Словники (Dictionary)', service: 'dictionary', key: 'dictionary-*' },
    { label: 'Словники профілів (Profile)', service: 'profile', key: 'dictionary-*' },
    { label: 'Заплановані задачі (Scheduled Jobs)', service: 'profile', key: 'scheduled-jobs-*' },
    { label: 'Шортлист (Shortlist)', service: 'shortlist', key: 'dictionary-*' },
    { label: 'Публічні вакансії (Vacancies Public)', service: 'vacancy', key: 'vacancies-public-*' },
    { label: 'Список рекрутерів (Recruiter List)', service: 'recruiter', key: 'recruiter-list-*' },
  ];

  public clearCache(service: string, key: string): void {
    this.adminService
      .clearCache(service, key)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.snackBar.open(`Кеш "${service}/${key}" очищено.`, 'OK', { duration: 3000 });
        },
        error: () => {
          this.snackBar.open(`Не вдалося очистити кеш "${service}/${key}".`, 'OK', { duration: 4000 });
        },
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
